import { render, staticRenderFns } from "./WebpartPreviewModal.vue?vue&type=template&id=8004387a"
import script from "./WebpartPreviewModal.vue?vue&type=script&lang=ts"
export * from "./WebpartPreviewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports